import React from 'react'
import { MerchantProvider } from '../template-tooling/context/merchant-context'
import ImageLibrary from './index'

const ImageLibraryProvider = () => {
  return (
    <MerchantProvider>
      <ImageLibrary />
    </MerchantProvider>
  )
}

export default ImageLibraryProvider
